import React from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg' | 'xl';
  fullWidth?: boolean;
}
// Simple utility for class merging if not existing
function classNames(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
export function Button({
  className,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide shadow-lg transform active:scale-95 transition-transform duration-100';
  const variants = {
    primary: 'bg-[#BE185D] hover:bg-[#9D174D] text-white border-b-4 border-[#831843] active:border-b-0 active:mt-1',
    secondary: 'bg-[#DB2777] hover:bg-[#BE185D] text-white border-b-4 border-[#9D174D] active:border-b-0 active:mt-1',
    outline: 'border-2 border-gray-900 text-gray-900 hover:bg-pink-50'
  };
  const sizes = {
    default: 'h-10 py-2 px-4 text-sm',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl md:text-2xl'
  };
  return <button className={classNames(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-265">
      {children}
    </button>;
}